import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../container/identifiers";
import {EventEmitter} from "../service/event-emitter";
import EVENTS from "../container/events";
import {Component} from "../interface/component";

@injectable()
export class EventsListingComponent implements Component {

    private $root:JQuery;

    private preview: boolean;

    @inject(SERVICE_IDENTIFIER.EVENTS) public eventEmitter: EventEmitter;

    init(elem:HTMLElement) {
        this.$root = $(elem);
        this.preview = this.$root.data('preview') ?? false;
        this.bindUI();
    }

    private bindUI() {
        this.eventEmitter.addListener(EVENTS.EVENT_LOAD_EVENT, this.loadEventDetails);
        if ('/events/' !== (<any>window).location.pathname && '/events' !== (<any>window).location.pathname) {
            let parts = (<any>window).location.pathname.split("/");
            let id = parts.pop();
            let slug = parts.pop();
            if ('page' !== slug) {
                this.loadEventDetails(id);
            }
        }
        this
            .$root
            .find('.js-event-listing__details')
            .on({
            click: (ev) => {
                ev.preventDefault();
                let $target = $(ev.currentTarget);
                let id = $target.data('id');
                this.eventEmitter.emit(EVENTS.EVENT_LOAD_EVENT, id);
            }
        })
    }

    private loadEventDetails = (id:number) => {
        let url = '/events/detail?id=' + id;
        if (this.preview) {
            url = url + '&preview=1';
        }
        $
            .ajax({
                type: 'GET',
                url: url
            })
            .done((responseData) => {
                this.eventEmitter.emit(EVENTS.HANDLE_EVENT_DETAIL, responseData);
            })
        ;
    }
}